import { Dialog } from "components/dialog";
import { Pencil, Trash } from "lucide-react";
import { useState } from "react";
import { CellContext } from "@tanstack/react-table";
import RoleACLEdit from "../../role-edit/RoleACLEdit";
import { ACLEntry } from "types";
import TooltipHorizon from "components/tooltip";

interface RoleRowActionProps {
  info: CellContext<ACLEntry, string>;
  deletingRowId: string | null;
  handleDeleteRow: (id: string) => void;
}

export const RoleRowAction: React.FC<RoleRowActionProps> = (props) => {
  const { info, deletingRowId, handleDeleteRow } = props;
  const role = info.row.original;
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="flex items-center gap-3">
      <Dialog
        header={`Edit role's permissions`}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        children={
          <RoleACLEdit permission={role.permissions} id={role.subject_id} />
        }
        trigger={
          <>
            <TooltipHorizon
              extra=""
              trigger={
                <button
                  className="rounded p-2 hover:bg-gray-100 dark:hover:bg-navy-700"
                  onClick={() => setIsOpen(true)}
                  disabled={deletingRowId?.trim().length > 0}
                >
                  <Pencil size={15} className="text-brand-500" />
                </button>
              }
              content={<span>Edit role</span>}
              placement="top"
            />
          </>
        }
      />
      <TooltipHorizon
        extra=""
        trigger={
          <button
            className="rounded p-2 hover:bg-gray-100 dark:hover:bg-navy-700"
            onClick={() => {
              handleDeleteRow(info.getValue());
            }}
            disabled={deletingRowId?.trim().length > 0}
          >
            <Trash size={15} className="text-red-500" />
          </button>
        }
        content={<span>Remove role</span>}
        placement="top"
      />
    </div>
  );
};
